import { Box } from "@chakra-ui/react";
import React from "react";

const Divider = () => {
  return (
    <Box
      borderRadius={"full"}
      height={"0.5"}
      width={10}
      bgColor={"#a2a2a2"}
      // mt={2}
    />
  );
};

export default Divider;
